// extracted by mini-css-extract-plugin
export var copyButton = "PayIdCopyField-module--copyButton--056f1";
export var field = "PayIdCopyField-module--field--af4f1";
export var frame = "PayIdCopyField-module--frame--89ff7";
export var label = "PayIdCopyField-module--label--2e850";
export var value = "PayIdCopyField-module--value--383aa";